import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Typo } from '@fragment/index';
import { Box, IconButton } from '@mui/material';
import useStyles from './ConfirmationModal.styles';
import { HeaderComponent } from '@zawarski/palmetto-ui-components';
import { MdClose } from 'react-icons/md';

const ConfirmationModal = ({
  open,
  setOpen,
  onSubmit,
  leftBtnText,
  rightBtnText,
  isSubmitting,
  title,
  message,
  rightBtnColor,
}) => {
  const classes = useStyles();
  const onClose = () => {
    if (isSubmitting) return null;
    setOpen && setOpen(false);
  };
  return (
    <Modal
      open={open}
      sx={{ overflow: 'hidden' }}
      onClose={onClose}
      contentStyle={classes.modalContent}>
      <Box sx={classes.modalContainer}>
        <HeaderComponent
          title={title}
          icon={
            <IconButton onClick={onClose}>
              <MdClose className={'icon'} />
            </IconButton>
          }
        />
        <Box sx={classes.content}>
          <Typo>{message}</Typo>
        </Box>
        <Box sx={classes.footer}>
          <Box sx={classes.footerWrapper}>
            <Button neutral={true} onClick={onClose}>
              {leftBtnText}
            </Button>
            <Button
              color={rightBtnColor}
              progress={isSubmitting}
              onClick={!isSubmitting ? onSubmit : undefined}>
              {rightBtnText}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  rightBtnColor: PropTypes.string,
  rightBtnText: PropTypes.string,
  leftBtnText: PropTypes.string,
  isSubmitting: PropTypes.bool,
};

ConfirmationModal.defaultProps = {
  open: false,
  isSubmitting: false,
  setOpen: () => {},
  onSubmit: () => {},
  title: 'Confirmation',
  message: 'Are you sure you want to proceed?',
  rightBtnText: 'SAVE',
  leftBtnText: 'CANCEL',
  rightBtnColor: 'primary',
};

export default ConfirmationModal;
